import * as actionTypes from "./actionTypes";

export const fetchBestContactInfo = (bestContactInfo) => {
  return {
    type: actionTypes.FETCH_BEST_CONTACT_INFO,
    bestContactInfo,
  };
};
export const resetBestContactInfo = () => {
  return {
    type: actionTypes.RESET_FETCH_BEST_CONTACT_INFO,
  };
};
